import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

function Success() {
  return (
    <>
      <Helmet>
        <title>Επιτυχής Παραγγελία - Ferupen Barbershop</title>
        <meta name="description" content="Η παραγγελία σας ολοκληρώθηκε επιτυχώς" />
      </Helmet>

      <div className="success-container">
        <div className="success-icon">
          <FaStar />
        </div>
        <h1>Επιτυχής Παραγγελία!</h1>
        <p>
          Ευχαριστούμε για την παραγγελία σας! Λάβαμε το αίτημά σας και θα επικοινωνήσουμε 
          σύντομα μαζί σας για την επιβεβαίωση.
        </p>
        <p>
          Θα λάβετε email επιβεβαίωσης στη διεύθυνση που δηλώσατε με όλες τις λεπτομέρειες 
          της παραγγελίας σας.
        </p>
        
        <div className="success-actions">
          <Link to="/">Επιστροφή στην Αρχική</Link>
          <Link to="/contact">Επικοινωνία</Link>
        </div>
      </div>
    </>
  );
}

export default Success;